import { Reducer } from "redux";

import { LanguageMasterResponse } from "../models/Api/Master";
import { LanguageDispatchTypes } from "../models/DispatchTypes/Master";
import { LanguageMasterActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

export const initialState: LanguageMasterResponse = {
  loading: false,
  response: [],
};

const MasterLanguageReducer: Reducer<
  LanguageMasterResponse,
  LanguageDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS: {
      setLocalStorageData(
        LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default MasterLanguageReducer;
